"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var rc_cascader_1 = tslib_1.__importDefault(require("rc-cascader"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
var PopupContainerProvider_1 = require("../PopupContainerProvider");
var input_1 = require("../Input/input");
var utils_1 = require("../utils");
var icons_1 = require("../icons");
var hooks_1 = require("../utils/hooks");
var defs_1 = require("../Form/defs");
// 根据 value 获取到选中的级联项
function getPathByValue(value, options) {
    var result = [];
    var i = 0;
    do {
        // eslint-disable-next-line no-loop-func
        var node = options.find(function (it) { return it.value === value[i]; });
        if (node) {
            result.push(node);
        }
        else {
            return result;
        }
        i++;
        options = node.children || [];
    } while (options.length > 0);
    return result;
}
function Cascader(props) {
    var valueFromProps = props.value, _a = props.defaultValue, defaultValue = _a === void 0 ? null : _a, options = props.options, style = props.style, sizeFromProps = props.size, validateStatus = props.validateStatus, placeholder = props.placeholder, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.expandTrigger, expandTrigger = _c === void 0 ? 'hover' : _c, onChange = props.onChange, className = props.className, overlayClassName = props.overlayClassName, rootHtmlProps = props.rootHtmlProps, dropdownHtmlProps = props.dropdownHtmlProps, restProps = tslib_1.__rest(props, ["value", "defaultValue", "options", "style", "size", "validateStatus", "placeholder", "disabled", "expandTrigger", "onChange", "className", "overlayClassName", "rootHtmlProps", "dropdownHtmlProps"]);
    var _d = hooks_1.useValue({ valueFromProps: valueFromProps, defaultValue: defaultValue, onChange: onChange }), value = _d.value, setValue = _d.setValue;
    var _e = react_1.useState(false), visible = _e[0], setVisible = _e[1];
    var size = defs_1.useFormSize(sizeFromProps);
    var prefix = ConfigProvider_1.usePrefix('cascader');
    var triggerClassName = classnames_1.default(input_1.useInputStyle({ size: size, validateStatus: validateStatus, disabled: disabled, focused: visible }), prefix, visible && utils_1.concat(prefix, 'active'), className, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    var iconClassName = utils_1.concat(prefix, 'icon');
    var handleChange = react_1.useCallback(function (innerValue, innerOptions) {
        setValue(innerValue, innerOptions);
    }, [setValue]);
    var displayLabels = react_1.useMemo(function () {
        var selectedOptions = getPathByValue(value || [], options || []);
        return selectedOptions.map(function (it) { return it.label; }).join(' / ');
    }, [value, options]);
    var contentClassName = classnames_1.default(utils_1.concat(prefix, 'content'), !displayLabels && utils_1.concat(prefix, 'placeholder'));
    var getPopupContainer = PopupContainerProvider_1.useGetPopupContainer();
    return (react_1.default.createElement(rc_cascader_1.default, tslib_1.__assign({ value: value, options: options, disabled: disabled, prefixCls: prefix, popupVisible: visible, onPopupVisibleChange: setVisible, onChange: handleChange, expandTrigger: expandTrigger, expandIcon: react_1.default.createElement(icons_1.RightThinIcon, null), dropdownRender: function (menu) { return react_1.default.createElement("div", tslib_1.__assign({}, dropdownHtmlProps), menu); }, popupClassName: classnames_1.default(overlayClassName, utils_1.concat(prefix, 'overlay', 'size', size)), getPopupContainer: getPopupContainer }, restProps, {
        // TODO：rc-cascader 目前没有将 `pupupAlign` 参数导出，但功能符合预期，已给 rc-cascader 组件提交 issue 希望导出该参数
        popupAlign: { offset: [0, 8] }
    }),
        react_1.default.createElement("div", tslib_1.__assign({}, rootHtmlProps, { className: triggerClassName, style: tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style) }),
            react_1.default.createElement("div", { className: contentClassName }, displayLabels || placeholder),
            react_1.default.createElement("div", { className: iconClassName },
                react_1.default.createElement(icons_1.DownIcon, { className: utils_1.concat(iconClassName, 'arrow') })))));
}
exports.default = Cascader;
//# sourceMappingURL=index.js.map